export type IntervalSchedule = { interval: number } | { intervals: number[] };

export interface IntervalScheduleCursor {
    stepIndex: number;
}

export function createIntervalScheduleCursor(): IntervalScheduleCursor {
    return { stepIndex: 0 };
}

export function resetIntervalScheduleCursor(
    cursor: IntervalScheduleCursor
): void {
    cursor.stepIndex = 0;
}

export function advanceIntervalScheduleCursor(
    cursor: IntervalScheduleCursor
): number {
    const consumed = cursor.stepIndex;
    cursor.stepIndex = consumed + 1;
    return consumed;
}

export function getIntervalDurationMs(
    schedule: IntervalSchedule,
    stepIndex: number
): number {
    if ("interval" in schedule) {
        return secondsToMs(schedule.interval);
    }

    const list = schedule.intervals;
    if (list.length === 0) {
        throw new Error("`intervals` must contain at least one value.");
    }
    const idx = Math.min(Math.max(stepIndex, 0), list.length - 1);
    const seconds = list[idx];
    if (seconds === undefined) {
        throw new Error("`intervals` must contain at least one value.");
    }
    return secondsToMs(seconds);
}

export function peekNextIntervalDurationMs(
    schedule: IntervalSchedule,
    cursor: IntervalScheduleCursor
): number {
    return getIntervalDurationMs(schedule, cursor.stepIndex);
}

function secondsToMs(seconds: number): number {
    if (!Number.isFinite(seconds) || seconds <= 0) {
        throw new Error(
            `Dwell interval must be a positive finite number of seconds (got ${seconds}).`
        );
    }
    return Math.floor(seconds * 1000);
}
